module.exports = __webpack_public_path__ + "static/media/First Light ZTG 3776_720.99762cc4.jpeg";